var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.itRef,staticClass:"shared-material"},[_c('p',[_vm._v(_vm._s(_vm.askTitle))]),_c('vh-checkbox',{model:{value:(_vm.isShared),callback:function ($$v) {_vm.isShared=$$v},expression:"isShared"}},[_vm._v(_vm._s(_vm.sharedTex))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }